import { createContext } from 'react';

import type { UserData } from 'src/hooks/helper';

const userData = {
  id: 0,
};

export const UserContext = createContext<UserData>(userData);

export const UserProvider = UserContext.Provider;
